// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import Iconify from 'src/components/iconify';
// ----------------------------------------------------------------------

const ICONS = {
  booking: <Iconify icon="mdi:search" />,
  visitsHistory: <Iconify icon="mdi:clipboard-text-history-outline" />,
  upcomingVisits: <Iconify icon="mdi:calendar-month" />,
  profiles: <Iconify icon="mdi:paw" />,
  store: <Iconify icon="mdi:store" />,
};

const getUserNavConfig = () => [
  {
    subheader: '',
    items: [
      {
        title: 'nav.myPets',
        path: PATH_DASHBOARD.general.profiles.root,
        icon: ICONS.profiles,
      },
      {
        title: 'nav.bookVisit',
        path: `${PATH_DASHBOARD.general.book.results}?type=all`,
        icon: ICONS.booking,
      },
      {
        title: 'nav.upcomingVisits',
        path: PATH_DASHBOARD.general.upcomingVisits,
        icon: ICONS.upcomingVisits,
      },
      {
        title: 'nav.visitHistory',
        path: PATH_DASHBOARD.general.history,
        icon: ICONS.visitsHistory,
      },
    ],
  },
];

export default getUserNavConfig;
